import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { WEBHOOK_SETTINGS_API } from '../api/webhooks-api';
import { WebhookInterface } from '../types/webhook-settings-interface';
export const useWebhookSettings = () => {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return WEBHOOK_SETTINGS_API;
      }
      return null;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: webhooks,
    mutate,
    isValidating
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== isValidating || $[4] !== mutate || $[5] !== webhooks) {
    t2 = {
      webhooks,
      mutate,
      isLoading: isValidating
    };
    $[3] = isValidating;
    $[4] = mutate;
    $[5] = webhooks;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};